export interface Drama {
  id: string;
  title: string;
  alias: string;
  cover: string;
  backdrop: string;
  synopsis: string;
  longSynopsis: string;
  director: string;
  cast: string[];
  genres: string[];
  year: number;
  region: string;
  language: string;
  totalEpisodes: number;
  updatedEpisodes: number;
  status: 'ongoing' | 'completed';
  updatedAt: string;
  weekUpdate: string;
  tags: string[];
  featured: boolean;
}

export const dramas: Drama[] = [
  {
    id: 'nanny',
    title: '迷人的保姆',
    alias: 'The Charming Nanny',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20family%20drama%20poster%2C%20elegant%20young%20woman%20in%20a%20neat%20grey%20housekeeper%20uniform%20standing%20in%20a%20warm%20sunlit%20modern%20living%20room%2C%20soft%20natural%20light%2C%20warm%20amber%20and%20deep%20navy%20tone%2C%20refined%20editorial%20composition%2C%20gentle%20expression%2C%20no%20text&width=600&height=800&seq=nanny-cover-a1&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Warm%20cinematic%20interior%20of%20an%20upscale%20modern%20apartment%20with%20large%20windows%2C%20golden%20afternoon%20sunlight%20streaming%20across%20soft%20linen%20sofa%20and%20potted%20plants%2C%20muted%20amber%20and%20deep%20navy%20tones%2C%20shallow%20depth%20of%20field%2C%20moody%20drama%20still%2C%20no%20text&width=1920&height=1080&seq=nanny-hero-bg-01&orientation=landscape',
    synopsis:
      '一位举止优雅、心思缜密的年轻保姆走进豪门之家，用温柔与智慧化解层层矛盾，也揭开了一段被掩埋多年的往事。',
    longSynopsis:
      '《迷人的保姆》以都市豪门家庭为背景，讲述主人公林晚（化名）以保姆身份进入顾家。她细致、从容、进退有度，很快赢得孩子们的依赖，却也触碰到家族内部难以言说的裂痕。随着日常相处的深入，一场关于亲情、信任与自我成长的旅程缓缓展开。她既是照料生活的人，也是照亮人心的那束光。',
    director: '周予安',
    cast: ['沈知微', '顾景行', '苏晚宁', '林亦辰', '周若彤'],
    genres: ['都市', '家庭', '情感'],
    year: 2026,
    region: '中国大陆',
    language: '普通话',
    totalEpisodes: 24,
    updatedEpisodes: 18,
    status: 'ongoing',
    updatedAt: '2026-10-12',
    weekUpdate: '每周五、周六各更新一集',
    tags: ['热播', '治愈', '豪门'],
    featured: true,
  },
  {
    id: 'trap',
    title: '温柔的陷阱',
    alias: 'Tender Trap',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20urban%20suspense%20drama%20poster%2C%20thoughtful%20young%20woman%20in%20a%20long%20coat%20standing%20beside%20a%20rain%20streaked%20window%20at%20dusk%2C%20cool%20steel%20blue%20with%20warm%20amber%20highlights%2C%20moody%20lighting%2C%20refined%20composition%2C%20no%20text&width=600&height=800&seq=trap-cover-a2&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Moody%20cinematic%20city%20night%20scene%20seen%20through%20rain%20covered%20glass%2C%20blurred%20warm%20window%20lights%20against%20deep%20blue%20shadows%2C%20urban%20suspense%20drama%20atmosphere%2C%20soft%20reflections%2C%20no%20text&width=1600&height=900&seq=trap-bd-02&orientation=landscape',
    synopsis: '一场看似温柔的相遇，背后却暗藏精心布置的迷局。真相与谎言之间，她必须做出选择。',
    longSynopsis:
      '《温柔的陷阱》讲述职场女性在一次偶然的善意相助后，卷入一场关于利益与真心的博弈。温柔可以是最暖的慰藉，也可以是最深的陷阱。',
    director: '陈默',
    cast: ['陆见川', '沈之遥', '许嘉禾'],
    genres: ['都市', '悬疑'],
    year: 2025,
    region: '中国大陆',
    language: '普通话',
    totalEpisodes: 24,
    updatedEpisodes: 6,
    status: 'completed',
    updatedAt: '2026-09-28',
    weekUpdate: '已完结，可完整观看',
    tags: ['悬疑', '口碑'],
    featured: false,
  },
  {
    id: 'mansion',
    title: '豪门保姆日记',
    alias: 'Diary of a Mansion Nanny',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20family%20drama%20poster%2C%20warm%20portrait%20of%20a%20kind%20housekeeper%20holding%20a%20tea%20tray%20in%20an%20elegant%20marble%20foyer%2C%20soft%20golden%20light%2C%20warm%20amber%20and%20deep%20navy%20palette%2C%20refined%20editorial%20style%2C%20no%20text&width=600&height=800&seq=mansion-cover-a3&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Grand%20elegant%20mansion%20hallway%20with%20marble%20floors%20and%20warm%20chandelier%20light%2C%20soft%20golden%20glow%2C%20rich%20amber%20and%20cream%20tones%2C%20cinematic%20family%20drama%20still%2C%20no%20text&width=1600&height=900&seq=mansion-bd-03&orientation=landscape',
    synopsis: '一位平凡保姆的日记，记录下豪门屋檐下的悲欢冷暖，也记录下一个家庭重新找回温度的旅程。',
    longSynopsis:
      '《豪门保姆日记》以保姆的第一视角展开，用一次次日常的工作片段，拼凑出一个看似完美家庭真实的模样。',
    director: '林月华',
    cast: ['顾青', '程亦涵', '叶南舟'],
    genres: ['家庭', '都市'],
    year: 2025,
    region: '中国大陆',
    language: '普通话',
    totalEpisodes: 30,
    updatedEpisodes: 6,
    status: 'completed',
    updatedAt: '2026-09-15',
    weekUpdate: '已完结，可完整观看',
    tags: ['温情'],
    featured: false,
  },
  {
    id: 'midnight',
    title: '深夜家政',
    alias: 'Midnight Housekeeping',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20healing%20drama%20poster%2C%20gentle%20woman%20in%20a%20simple%20apron%20standing%20in%20a%20dim%20cozy%20apartment%20late%20at%20night%2C%20warm%20lamp%20glow%20against%20deep%20navy%20shadows%2C%20quiet%20emotional%20mood%2C%20refined%20composition%2C%20no%20text&width=600&height=800&seq=midnight-cover-a4&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cozy%20apartment%20kitchen%20at%20midnight%2C%20single%20warm%20lamp%20glow%2C%20deep%20blue%20shadows%20and%20amber%20highlights%2C%20quiet%20healing%20drama%20atmosphere%2C%20soft%20textures%2C%20no%20text&width=1600&height=900&seq=midnight-bd-04&orientation=landscape',
    synopsis: '每当城市入睡，她的夜晚才刚开始。一次次深夜家政，遇见一个个需要被倾听的人。',
    longSynopsis:
      '《深夜家政》讲述一位夜间上门服务者，在深夜的城市里穿行，用整理房间的方式，也整理着陌生人凌乱的心。',
    director: '许一诺',
    cast: ['苏可', '江屿', '孟亭'],
    genres: ['都市', '治愈'],
    year: 2026,
    region: '中国大陆',
    language: '普通话',
    totalEpisodes: 22,
    updatedEpisodes: 6,
    status: 'ongoing',
    updatedAt: '2026-10-08',
    weekUpdate: '每周三更新两集',
    tags: ['治愈', '慢节奏'],
    featured: false,
  },
  {
    id: 'secondlife',
    title: '她的第二次人生',
    alias: 'Her Second Life',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20inspiring%20drama%20poster%2C%20confident%20young%20woman%20in%20a%20simple%20white%20shirt%20walking%20through%20a%20bright%20city%20street%20in%20morning%20light%2C%20optimistic%20mood%2C%20warm%20amber%20and%20soft%20navy%20tones%2C%20refined%20editorial%20composition%2C%20no%20text&width=600&height=800&seq=secondlife-cover-a5&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Bright%20morning%20city%20street%20with%20warm%20sunlight%20filtering%20through%20trees%2C%20hopeful%20inspiring%20drama%20atmosphere%2C%20soft%20amber%20and%20clean%20neutral%20tones%2C%20no%20text&width=1600&height=900&seq=secondlife-bd-05&orientation=landscape',
    synopsis: '跌倒之后，她选择重新站起来。一次关于勇气与自我重建的温柔叙事。',
    longSynopsis:
      '《她的第二次人生》讲述一位女性在人生低谷后重新出发的故事，用细腻的笔触描写职场、亲情与自我价值的重建。',
    director: '唐宁',
    cast: ['白露', '顾亦舟', '温言'],
    genres: ['情感', '励志'],
    year: 2025,
    region: '中国大陆',
    language: '普通话',
    totalEpisodes: 28,
    updatedEpisodes: 6,
    status: 'completed',
    updatedAt: '2026-08-30',
    weekUpdate: '已完结，可完整观看',
    tags: ['励志'],
    featured: false,
  },
  {
    id: 'keeper',
    title: '幸福里的守望者',
    alias: 'Keeper of Happiness',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20nostalgic%20family%20drama%20poster%2C%20warm%20portrait%20of%20a%20woman%20standing%20in%20an%20old%20courtyard%20alley%20with%20bicycles%2C%20soft%20golden%20evening%20light%2C%20amber%20and%20deep%20teal%20tones%2C%20nostalgic%20refined%20style%2C%20no%20text&width=600&height=800&seq=keeper-cover-a6&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Old%20Chinese%20residential%20alley%20at%20golden%20hour%2C%20warm%20sunlight%20on%20aged%20brick%20walls%2C%20bicycles%20and%20laundry%20lines%2C%20nostalgic%20family%20drama%20atmosphere%2C%20amber%20and%20soft%20teal%20tones%2C%20no%20text&width=1600&height=900&seq=keeper-bd-06&orientation=landscape',
    synopsis: '一条老街，几户人家，在岁月流转中守望彼此的幸福与团圆。',
    longSynopsis:
      '《幸福里的守望者》以老街邻里为舞台，讲述普通人在时代变迁里彼此扶持、守望相助的温暖故事。',
    director: '赵建军',
    cast: ['陈玉兰', '周铭', '孙晓晓'],
    genres: ['家庭', '年代'],
    year: 2024,
    region: '中国大陆',
    language: '普通话',
    totalEpisodes: 32,
    updatedEpisodes: 6,
    status: 'completed',
    updatedAt: '2026-08-12',
    weekUpdate: '已完结，可完整观看',
    tags: ['年代', '温情'],
    featured: false,
  },
  {
    id: 'backlight',
    title: '逆光而来',
    alias: 'Against the Light',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20youth%20drama%20poster%2C%20young%20woman%20silhouette%20standing%20against%20warm%20backlit%20window%20in%20an%20empty%20studio%2C%20sunlight%20flare%2C%20amber%20glow%20and%20deep%20navy%20shadows%2C%20refined%20composition%2C%20no%20text&width=600&height=800&seq=backlight-cover-a7&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Warm%20backlit%20empty%20dance%20studio%20with%20sunlight%20streaming%20through%20tall%20windows%2C%20dust%20motes%20in%20the%20air%2C%20amber%20glow%20and%20navy%20shadows%2C%20cinematic%20youth%20drama%20still%2C%20no%20text&width=1600&height=900&seq=backlight-bd-07&orientation=landscape',
    synopsis: '她迎着光走来，也走进自己的梦想里。一个关于热爱与坚持的青春故事。',
    longSynopsis:
      '《逆光而来》讲述一群年轻人追逐舞台梦想的过程，在汗水与坚持中，找到属于自己的那束光。',
    director: '方圆',
    cast: ['林之夏', '程野', '南歌'],
    genres: ['都市', '青春'],
    year: 2026,
    region: '中国大陆',
    language: '普通话',
    totalEpisodes: 20,
    updatedEpisodes: 6,
    status: 'ongoing',
    updatedAt: '2026-10-05',
    weekUpdate: '每周四更新两集',
    tags: ['青春'],
    featured: false,
  },
  {
    id: 'smallnanny',
    title: '家有俏保姆',
    alias: 'A Nanny at Home',
    cover:
      'https://readdy.ai/api/search-image?query=Bright%20lighthearted%20Chinese%20family%20comedy%20poster%2C%20cheerful%20young%20nanny%20holding%20a%20plate%20of%20steaming%20food%20in%20a%20sunny%20kitchen%2C%20warm%20amber%20and%20fresh%20cream%20tones%2C%20joyful%20refined%20style%2C%20no%20text&width=600&height=800&seq=smallnanny-cover-a8&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Sunny%20bright%20family%20kitchen%20with%20steaming%20dishes%20on%20the%20table%2C%20warm%20morning%20light%2C%20cheerful%20comedy%20atmosphere%2C%20fresh%20amber%20and%20cream%20tones%2C%20no%20text&width=1600&height=900&seq=smallnanny-bd-08&orientation=landscape',
    synopsis: '厨房里飘出饭菜香，也飘出一个个啼笑皆非的日常。有她在，家就热闹起来。',
    longSynopsis:
      '《家有俏保姆》用轻喜剧的方式讲述一位活泼保姆与雇主一家相处的爆笑日常，笑中带暖。',
    director: '何欢',
    cast: ['米粒', '高远', '乐乐'],
    genres: ['喜剧', '家庭'],
    year: 2024,
    region: '中国大陆',
    language: '普通话',
    totalEpisodes: 20,
    updatedEpisodes: 6,
    status: 'completed',
    updatedAt: '2026-07-22',
    weekUpdate: '已完结，可完整观看',
    tags: ['轻喜剧'],
    featured: false,
  },
];

export const mainDramaId = 'nanny';

export const secondaryDramaIds = [
  'trap',
  'mansion',
  'midnight',
  'secondlife',
  'keeper',
  'backlight',
  'smallnanny',
];

export const dramaGenreOptions = ['都市', '家庭', '情感', '悬疑', '治愈', '励志', '年代', '青春', '喜剧'];

export const dramaStatusOptions = [
  { value: 'all', label: '全部' },
  { value: 'ongoing', label: '连载中' },
  { value: 'completed', label: '已完结' },
];